module.exports = __webpack_public_path__ + "static/img/Bachelor_010159.b571ed5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010159.jpg
// module id = 118
// module chunks = 0